module.exports = __webpack_public_path__ + "img/yq.5ffa5773.png";